var cashColor = "https://shopfront-cdn.tekoapis.com/static/fae4d10b55525aea.svg";

export { cashColor as default };
